import * as client from '../../services/client';
import { TYPES } from '../../common/constants';

const fetchRecentActivityDone = payload => ({
    type: TYPES.FETCH_RECENT_ACTIVITY_DONE,
    payload,
  });
  
  export const fetchRecentActivity = (id) => dispatch => {
    return client.getRecentActivity(id)
      .then(
        response => {
          if(response.ok || response.status === 200){
            response.json().then(responsejson =>{                
              dispatch(fetchRecentActivityDone(responsejson))
            })
          }
        },
      );
  };
  